import { mapServerSideChannel } from '@/utils/api.mapper'
import { getInstanceWithToken } from '@/utils/axios'
import { Channel, ServerSideChannel } from './types'

/* eslint-disable */

/* eslint-enable */

export interface FetchChannelsRequest {
  appId?: number
  idHash?: string
}

export const fetchChannels = async (req: FetchChannelsRequest): Promise<Channel[]> => {
  const { data } = req.appId
    ? await getInstanceWithToken().get<any>(`/api/app/v1/channels?app_id=${req.appId}&type[]=1&type[]=2&type[]=4`)
    : await getInstanceWithToken().get<any>('/api/app/v1/channels?type[]=1&type[]=2&type[]=4')

  const result: ServerSideChannel[] = data.data

  return result.map(mapServerSideChannel)
}

export interface CreateChannelRequest {
  appId?: number
  idHash?: string
  name?: string
  type?: number
  clientId?: number
  description?: string
  imageId?: number
  tariffIds?: number[]
  promotional_page_id?: number
}

export const createChannel = async (req: CreateChannelRequest): Promise<Channel> => {
  const { data } = await getInstanceWithToken().post<ServerSideChannel>('/api/app/v1/channels', {
    app_id: req.type !== 3 ? req.idHash : undefined,
    name: req.name,
    type: req.type,
    client_id: req.clientId,
    description: req.description,
    image_id: req.imageId ? req.imageId : undefined,
    // tariffs: req.tariffIds ? req.tariffIds.map((v) => Number(v)) : undefined,
    promotional_page_id: req.promotional_page_id ?? undefined
  })
  return mapServerSideChannel(data.data)
}

export interface UpdateChannelRequest {
  id: number
  name?: string
  appId?: number
  description?: string
  imageId?: number
  tariffIds?: number[]
  promotional_page_id?:number
}

export const updateChannel = async (req: UpdateChannelRequest): Promise<Channel> => {
  const { data } = await getInstanceWithToken().put<ServerSideChannel>(
    `/api/app/v1/channels/${req.id}`,
    {
      name: req.name,
      image_id: req.imageId ? req.imageId : undefined,
      tariffs: req.tariffIds ? req.tariffIds.map((v) => Number(v)) : undefined,
      promotional_page_id : req.promotional_page_id ?? undefined
    }
  )

  return mapServerSideChannel(data.data)
}

export interface DeleteChannelRequest {
  id: number
}

export const deleteChannel = async (req: DeleteChannelRequest): Promise<void> => {
  await getInstanceWithToken().delete<ServerSideChannel>(`/api/app/v1/channels${req.id}`)
}
